const o="roq",r="roq-";export{r as COMPONENT_CLASS_PREFIX,o as ROQ_PREFIX};